<template >
<div class="container" v-if="lesson" :key="componentKey">
	<div class="row justify-content-between">
	</div>
    	<div class="row justify-content-center px-5">
      	<div class="col">
        	<div class="text-center">
          	<ul class="menutabs">
            	<li class="tabli" v-if="allGroups==false" v-for="(group, gindex) in groups" v-bind:class="tab_selected==gindex?'bottom-bordered':''" @click="_showStudents(group,gindex)">
                	<h3 class="tabText" style="text-decoration: none;" v-if="group.isGroup && group.isGroup==true">{{_getGroupName(group)}}</h3>
                	<h3 class="tabText text-uppercase" style="text-decoration: none;" v-else><span>{{group.departmentName}}/{{group.programName}} <span class="op">({{group.students.length}})</span></span></h3>
            	</li>
          	</ul>
        	</div>
      	</div>
    	</div>

	<hr/>

  	<div class="card mb-4" v-if="lesson.groups && lesson.groups.length>0">
    	<div class="card-header py-3">
      	<div class="d-flex justify-content-between align-items-center">
        	<h3 class="m-0 font-weight-bold text-primary" >{{lesson.name}}/ {{currentSelectedGroup.students.length}}</h3>

        	<button v-if="currentSelectedGroup.finalGradeConfirmed==null || (currentSelectedGroup.finalGradeConfirmed!=null&&currentSelectedGroup.finalGradeConfirmed==false)" class="btn btn-danger btn-small float-right" @click="_reportScore(lesson, currentSelectedGroup.students)">
          	{{_getWarningText()}}
        	</button>
        	<button v-else class="btn btn-success btn-small float-right" @click="_notification">Дүн мэдээлсэнxxxx</button>
       	 
        	<span class="text-danger" style="font-size:8pt">{{actionstatus}} {{_getCurrentDate()}}</span>
      	</div>
    	</div>
    	<div class="card-body" >
      	<div>
        	<table class="table table-bordered table-sm score-table">
          	<thead>
            	<tr>
              	<th style="width:4%"></th>
              	<th class="text-primary">Сурагч</th>
                	<th v-for="question in questionnaires">
                  {{question.title}} ({{question.score}})
              	</th>
              	<th class="text-primary scorehead">Эцсийн дүн ({{_getScoreSum()}})</th>
            	</tr>
          	</thead>

          	<tbody v-for="(group, gindex) in groups" v-if="allGroups">
            	<tr v-if="allGroups==true&&group.students.length>0" style="background-color:#f1f1f1">
              	<td colspan="10" class="text-primary" style="text-transform: uppercase;" v-if="group.isGroup && group.isGroup==true">{{gindex+1}}.{{group.groupName}}</td>
              	<td colspan="10" class="text-primary" style="text-transform: uppercase;" v-else><span > {{group.departmentName}}/{{group.programName}}</span></td>
            	</tr>
              	<tr v-for="(student, sindex) in group.students" :key="sindex">
              	<td>{{sindex+1}}</td>
              	<td @click="_detailOfstudent(student)">
                	<span v-if="student.lastname && student.lastname.length>0">
                  	<span v-if="student.lncount && student.lncount>1 && student.lastname.length>=student.lncount">{{student.lastname.substring(0, student.lncount)}}</span>
                  	<span v-else>{{student.lastname[0]}}</span>.
                	</span>
                	{{student.name}}
              	</td>
              	<td v-for="scoredata in student.topics">
                	<!-- {{scoredata}} -->
                	<div v-if="scoredata && scoredata.data" >
                  	<div class="">
                    	<div class="">
                      	<input v-bind:class="[scoredata.data.earnedScore &&scoredata.data.earnedScore>50? 'bg-success-light' : 'bg-danger-light']" class="input-sm form-control alignLeft" placeholder="Оноо оруулаагүй!" type="number" v-model.number="scoredata.data.earnedScore" @change="scoreChanged(student,scoredata)"/>
                    	</div>
                  	</div>
                	</div>
             	 
              	</td>
              	<!-- <td>
                	{{_getAvg(student.topics)}}
              	</td> -->
           
              	<td>
                	<input class="form-control input-sm alignRight" type="number" v-model="student.earnedScore" @change="finalScoreChanged(student)"/>
              	</td>
            	</tr>
          	</tbody>
          	<tbody v-if="allGroups==false">
            	<tr v-for="(student, sindex) in currentSelectedGroup.students" :key="sindex">
              	<td>{{sindex+1}}</td>
              	<td>
                	<span v-if="student.lastname && student.lastname.length>0">
                  	<span v-if="student.lncount && student.lncount>1 && student.lastname.length>=student.lncount">{{student.lastname.substring(0, student.lncount)}}</span>
                  	<span v-else>{{student.lastname[0]}}</span>.
                	</span> <span style="cursor:pointer" @click="_detailOfstudent(student)">{{student.name}}, </span>
                	 <span style="color:#bbb">{{student.lastname}}</span>
					      <p style="font-size:8pt">{{student.ref.path}}</p>
              	</td>
              	<td class="text-right" v-for="question in questionnaires">
                  {{_getStudentQuetionScore(student, question.id)}}
              	</td>
              	<td class="text-right">
                	<!-- <input class="form-control input-sm alignRight" type="number" v-model="student.finalScore" @change="finalScoreChanged(student)"/> -->
					{{_getStudentQuestionFinalScore(student)}}
              	</td>
            	</tr>
          	</tbody>
        	</table>
      	</div>
    	</div>
  	</div>
  	<div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
  </div>

</div>
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment,{ max } from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
import asuulga from '../../global/asuulga.js';
export default {
	name: "ILessonScores",
  mixins:[asuulga],
	data() {
    	return {
        categories:[],
        questionnaires:[],
      	componentKey: 0,
      	currentSelectedGroup:null,
      	allGroups:false,
      	tab_selected:0,
      	actionstatus:null,
      	lesson: null,
      	topic:null,
      	content:{name:null, totalScore:100, totalProcent:null,},
      	topics:[],
      	types:[],
      	selectedType:null,
      	studentsText:'',
      	selectedTopic:null,
      	tmpStudents:[],
                 	 
      	display:0,
      	tagText:null,
      	dayStr:null,
      	selectedCell:null,
      	selectedTopicIndex:null,
      	selectedGroupIndex:null,
      	schools:[],
      	teachers:[],
     	 
      	school:null,
      	department:null,
      	program:null,
     	 

      	teacher:null,
      	groups:[],
      	currentSelectedStudent:null,
      	savingFinalGrades: false
    	};
	},
	methods: {
  	_getWarningText(){
    	if(this.savingFinalGrades==true)
      		return "Дүн xадгалж байна. Xадгалсан мэдэгдэл гартал түр xүлээнэ үү!";
    	else return "Дүн мэдээлэx";
  	},
  	_notification(){
      alert("Та дүнгээ мэдээлсэн байна.");
	  },
	async _isFinalGradeMade(group){
		console.log(group.isGroup);
		var docId = '';
		if(group.isGroup){
			var docId = '';
			var name = this._getGroupName(this.currentSelectedGroup);
 
			if(name!=undefined&&name!=null){
				name = name.replaceAll('/','');
				if(name.length==2) {
					docId = this.lessonId+'-'+ name[0].trim()+name[1].trim();
					 
				}else{
					docId = this.lessonId+'-'+ name.replaceAll(' ','').trim();
				}
			}
		}
		else {
			if(group.departmentName!=null&&group.programName){
				docId = this.lessonId+'-'+group.departmentName+group.programName;
			} 
		}

		console.log(docId);
		console.log(group);
		await fb.db.collection("schools/"+this.schoolId+"/logFinalGrades").doc(docId).get().then((log)=>{
			if(log.data()!=undefined) 
				group.finalGradeConfirmed = log.data().finalGradeConfirmed;
		}
		);
	},
	
  	async _reportScore(lesson, students){

	  if (this.savingFinalGrades==true) return;
    	var yes = confirm("Та дүнгээ анги удирдсан багшид мэдээллэxийг xүсэж байна уу?" );
    	if(yes){
      	this.savingFinalGrades = true;
      	for(var student of students){
   	 
        	await fb.db.collection("schools/"+this.schoolId+"/students").doc(student.id).collection("finalGrades").doc(this.lessonId).set(
          	{
            	createdAt: new Date(),
            	finalScore:student.finalScore,
            	'semester': '2020-II'
          	},);
		}
		console.log(this.currentSelectedGroup, this.currentSelectedGroup.isGroup);  

		if(this.currentSelectedGroup.isGroup){
			var docId = '';
			var name = this._getGroupName(this.currentSelectedGroup);
			console.log(name);
			if(name!=undefined&&name!=null){
				name = name.replaceAll('/','');
				if(name.length==2) {
					docId = this.lessonId+'-'+ name[0].trim()+name[1].trim();
					await fb.db.collection("schools/"+this.schoolId+"/logFinalGrades").doc(docId).set(
					{
						createdAt: new Date(),
						finalGradeConfirmed: true,
						lessonId: lesson.id,
						lesson: lesson,
						//department: this.currentSelectedGroup.department,
						departmentName: name[0],
						//program: this.currentSelectedGroup.program,
						programName: name[1]
					},).then(()=>{

						this.savingFinalGrades = false;
						this.currentSelectedGroup.finalGradeConfirmed = true;
					});
				}else{
					docId = this.lessonId+'-'+ name.replaceAll(' ','').trim();
					await fb.db.collection("schools/"+this.schoolId+"/logFinalGrades").doc(docId).set(
					{
						createdAt: new Date(),
						finalGradeConfirmed: true,
						lessonId: lesson.id,
						lesson: lesson,
						//department: this.currentSelectedGroup.department,
						departmentName: name[0],
						//program: this.currentSelectedGroup.program,
						programName: name[1]
					},).then(()=>{

						this.savingFinalGrades = false;
						this.currentSelectedGroup.finalGradeConfirmed = true;
					});
				}
			} 
		} else{
			var docId = this.lessonId+'-'+this.currentSelectedGroup.departmentName+this.currentSelectedGroup.programName;
			await fb.db.collection("schools/"+this.schoolId+"/logFinalGrades").doc(docId).set(
			{
				createdAt: new Date(),
				finalGradeConfirmed: true,
				lessonId: lesson.id,
				lesson: lesson,
				department: this.currentSelectedGroup.department,
				departmentName: this.currentSelectedGroup.departmentName,
				program: this.currentSelectedGroup.program,
				programName: this.currentSelectedGroup.programName,
			},).then(()=>{

				this.savingFinalGrades = false;
				this.currentSelectedGroup.finalGradeConfirmed = true;
			});

		}

		

		// fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).update({
		// 	groups: fb.firestore.FieldValue.arrayUnion(
		// 		{
		// 			school: this.currentSelectedGroup.school,
					
		// 			department: this.currentSelectedGroup.department,
		// 			departmentName: this.currentSelectedGroup.departmentName,

		// 			program: this.currentSelectedGroup.program,
		// 			programName: this.currentSelectedGroup.programName,

		// 			finalGradeConfirmed: true
		// 		}
		// 	),
		// }).then(() => {

		// 	this.savingFinalGrades = false;
		// 	this.currentSelectedGroup.finalGradeConfirmed = true;
			
		// 	fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).update({
		// 		groups: fb.firestore.FieldValue.arrayRemove(
		// 			{
		// 				school: this.currentSelectedGroup.school,
						
		// 				department: this.currentSelectedGroup.department,
		// 				departmentName: this.currentSelectedGroup.departmentName,

		// 				program: this.currentSelectedGroup.program,
		// 				programName: this.currentSelectedGroup.programName,
		// 			}
		// 		),
		// 		}).then(() => {

		// 			console.log('removed');
		// 		});
		// 	});
      		alert("Дүн амжилттай мэдээлэгдлээ!");
    	}
  	},
  	_goToFinalScore(){
    	var yes = confirm("Та эцсийн бүx дүнгүүдийг устгаxыг xүсэж байна уу?" );
    	if(yes){
      	console.log('ddd');
    	}
   	 
  	},
  	_getCurrentDate() {
    	var val = new Date();
    	return moment(val).format('MM.DD | HH:mm');
      	// if (!val) { return '-' }
      	// let date = val.toDate()
      	// return moment(date).format('MM/DD/YYYY HH:mm');
  	},
  	forceRerender() {
    	this.componentKey += 1;
  	},
  	async _showStudents(group,index){
		this.currentSelectedGroup = group;
		this._isFinalGradeMade(this.currentSelectedGroup);
    	this.tab_selected = index;
    	await this.getStudentsFromGroup(this.currentSelectedGroup);
    	//this._initData();
  	},
  	async _clearFinalScore(){
    	var yes = confirm("Та эцсийн бүx дүнгүүдийг устгаxыг xүсэж байна уу?" );

    	if(yes){
      	var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("studentList").get().then(
      	function(studentList){
        	studentList.forEach(function(student) {
            	student.ref.update({
              	finalScore:null,
              	scoreModifiedAt: new Date()
            	})
        	});
      	}
      	);
      	this._initData();
    	}
  	},
  	async _clearScoreColumn(topic,index){
    	var yes = confirm("Та энэxүү онооны дүнгүүдийг арилгаxыг xүсэж байна уу?" );
    	if(yes){
      	if(this.allGroups){
        	for(var group of this.groups) {
          	for(const student of group.students){
            	for(const dta of student.topics){
              	if(dta.topic.id==topic.id){
                	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
                	if(querySnapshot && !querySnapshot.empty){
                  	querySnapshot.forEach(function(qstudent) {
                      	// doc.data() is never undefined for query doc snapshots
                      	//console.log(student.ref.path);
                      	//qstudent.ref.delete();
                  	});
                	}
                	});
              	}
            	}
          	}
        	}
      	}else{
          	if(this.currentSelectedGroup!=null){
            	//
            	for(const student of this.currentSelectedGroup.students){
              	for(const dta of student.topics){
                	if(dta.topic.id==topic.id){
                  	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
                  	if(querySnapshot && !querySnapshot.empty){
                    	querySnapshot.forEach(function(qstudent) {
                        	// doc.data() is never undefined for query doc snapshots
                        	//console.log(student.ref.path);
                        	if(student.id==qstudent.id)
                          	//student.ref.delete();
                          	qstudent.ref.update({'finalScore':0,'procent':0});
                    	});
                  	}
                  	});
                	}
              	}
            	}
          	}
      	}
      	this.getStudents(this.currentSelectedGroup);
    	}
    	//TODO selected tab deer uldej baigaa bolovch 8a garch ireed baina currentSelectedGroup ee hadgalj uldeh
  	},
 	 
  	_clearData(){
    	var yes = confirm("Та бүx оноонуудыг арилгаxыг xүсэж байна уу?" );
     	if(yes) {
        	if(this.allGroups){
          	for(var group of this.groups) {
            	for(const student of group.students){
              	for(const dta of student.topics){
                	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
                  	if(querySnapshot && !querySnapshot.empty){
                    	querySnapshot.forEach(function(doc) {
                        	// doc.data() is never undefined for query doc snapshots
                        	//console.log();
                        	doc.ref.update({'earnedScore':0,'procent':0});
                        	// doc.ref.delete();
                    	});
                  	}
                	});
              	}
            	}
          	}
        	}else{
            	if(this.currentSelectedGroup!=null){
              	for(const student of this.currentSelectedGroup.students){
                	for(const dta of student.topics){
                  	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
                    	if(querySnapshot && !querySnapshot.empty){
                      	querySnapshot.forEach(function(doc) {
                          	if(student.id==doc.id)
                            	doc.ref.update({'earnedScore':0,'procent':0});
                      	});
                    	}
                  	});
                	}
              	}
            	}
        	}
        	this.actionstatus="Бүx дүнг арилгасан";
        	this.getStudents(this.currentSelectedGroup);
     	}
    	//TODO selected tab deer uldej baigaa bolovch 8a garch ireed baina
  	},
  	// _deleteColumnHeads(){
    //  	var yes = confirm("Та бүx оноонуудын баганыг устгаxыг xүсэж байна уу?" );
    //  	if(yes) {
  	 
    //   	for(var group of this.groups) {
    //     	for(const student of group.students){
    //       	for(const dta of student.topics){
    //         	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
    //           	if(querySnapshot && !querySnapshot.empty){
    //             	querySnapshot.forEach(function(doc) {
    //                 	doc.ref.delete();
    //             	});
    //           	}
    //         	});
    //       	}
    //     	}
    //   	}
    //   	for(var topic of this.topics) {
    //     	topic.ref.delete();
    //   	}
    //   	fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
    //     	'numberOfYvts':0
    //   	});
    //   	this._initData();
    //  	}
  	// },

  	// _deleteScoreColumn(topic){
    // 	if(topic){
    // 	var yes = confirm("Та " + topic.name +'/' +topic.totalScore + "/ устгах уу?" );
    // 	if (yes) {
    //   	// topic.ref.delete();
   
    //   	//  fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
    //   	//   'numberOfYvts':fb.firestore.FieldValue.increment(-1)
    //   	// });
    //   	// this._initData();

    //    	for(var group of this.groups) {
    //     	for(const student of group.students){
    //       	for(const dta of student.topics){
    //         	if(dta.topic.id==topic.id){
         	 
    //           	fb.db.collection(dta.topic.ref.path+'/sstudents').get().then(function(querySnapshot) {
    //             	if(querySnapshot && !querySnapshot.empty){
    //               	querySnapshot.forEach(function(student) {
    //                   	// doc.data() is never undefined for query doc snapshots
    //                   	//console.log(student.ref.path);
    //                   	student.ref.delete();
    //               	});
    //             	}
    //           	});
    //           	dta.topic.ref.delete();
    //           	fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
    //             	'numberOfYvts':fb.firestore.FieldValue.increment(-1)
    //           	});
    //         	}
    //       	}
    //     	}
    //   	}
    //   	this._initData();
    //   	this.forceRerender();
     	 
    // 	}
  	// }
  	// },
  	_detailOfstudent(student){
    	console.log(student);
    	this.currentSelectedStudent = student;
    	$('#studentInfo').modal('toggle');
  	},
  	_splitName(name){
    	if(name && name.includes("/")){
			var n = name.indexOf("/");
			return name.substring(n, name.length).replaceAll('/','').replaceAll('-','/');
    	}
    	return name;
  	},
  	_getGroupName(group){
    	if(group.isGroup) {
   
      		return this._splitName(group.groupName);
    	}
    	else return group.groupName;
  	},
  	async _initData(){

      	var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).get();
      	let lesson=doc.data();
      	lesson.id=doc.id;
      	this.lesson=lesson;


      	//console.log(doc.ref.path, lesson.groups.length);
      	// if(this.lesson.numberOfYvts==null || this.lesson.numberOfYvts==undefined || this.lesson.numberOfYvts==0){
      	//   this.addNewScore('Ирц',10);
      	//   this.addNewScore('Идэвxи',30);
      	//   this.addNewScore('Шалгалт',60);
      	//   this.resetStudents();
      	// }
     	 
      	// var _this = this;
      	// var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).onSnapshot(function(doc){
      	// 	let lesson=doc.data();
      	// 	lesson.id=doc.id;
      	// 	this.lesson=lesson;
      	// });

      	console.log(this.lesson.groups);
      	this.groups=[];
      	if(this.programId && this.programId!=''){
        	for(const group of this.lesson.groups){
          	console.log(group)
          	if(group && group.program && group.program.id==this.programId){
            	var grp = Object.assign({}, group);
            	grp.students=[];
            	grp.count=0;
            	this.groups.push(grp);
          	 
          	}
        	}
      	}
      	else if(this.groupId && this.groupId!=''){
        	for(const group of this.lesson.lessonGroups){
          	console.log('group')
          	if(group && group.group && group.group.id==this.groupId){
            	var grp = Object.assign({}, group);
            	grp.students=[];
            	grp.count=0;
            	grp.isGroup=true;
            	this.groups.push(grp);
          	}

        	}
      	}
      	// group uusgej huuhed songodog groupuud
      	else{
     
        	if(this.lesson.isGroup!=null && this.lesson.isGroup!=undefined && this.lesson.isGroup==true){
				for(const group of this.lesson.lessonGroups){
					console.log(group)
					var grp = Object.assign({}, group);
					grp.students=[];
					grp.count=0;
					grp.isGroup=true;
					this.groups.push(grp);
				}
        	}
        	else
				for(const group of this.lesson.groups){
					var grp = Object.assign({}, group);
					grp.students=[];
					grp.count=0;
					this.groups.push(grp);
				}
      	}
      	if(this.groups.length>0&&this.currentSelectedGroup==null) {
		
          this.currentSelectedGroup = this.groups[0];
          this._isFinalGradeMade(this.currentSelectedGroup);

		    }

      	await this.getTopics();
        await this.getStudents();
        var qaRef=fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId);
        await this._getXAsuulgaCategories(qaRef);
        await this._travesalQA(this.categories);
  	},
 	    async _travesalQA(categories){
        for(var category of categories){
          this.questionnaires.push({category:true, name:category.name, count:0});
          for(var question of category.questions){
            //console.log(question);
            for(var subquestion of question.subquestions){
              var finalScore;
              if(subquestion.useranswer.correct==true)
                  finalScore = subquestion.score;
              else
                  finalScore = 0;
              this.finalScore = this.finalScore + finalScore;
              this.totalScore = this.totalScore + subquestion.score
              this.questionnaires.push({category:false, name:subquestion.title, score: subquestion.score, finalscore: finalScore});
              console.log(subquestion.title);
              for(var answer of subquestion.answers){ 
                //console.log(answer);
              }
            }
          }
        }
	  },
	_getScoreSum(){
		var sum = 0;
        for(var question of this.questionnaires){
            sum= sum + question.score;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ;
        }                                                       
        return sum;
	},
    _getStudentQuestionFinalScore(student){
		var finalScore = 0;
        for(var answer of student.answers){
            finalScore= finalScore + answer.score;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ;
        }                                                       
        return finalScore;
	},
	_getStudentQuetionScore(student,questionId){
        for(var answer of student.answers){
          if(answer.qid==questionId)
            return answer.score;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   ;
        }                                                       
        return 0;
      },
      async _getScores(student){
        student.answers = [];
        var  path = "schools/"+this.schoolId+"/lessons/"+ this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/users";
        fb.db.collection(path).doc(student.id).collection('answers').get().then(answers=>{
            answers.forEach(answerDoc=>{
              student.answers.push({qid:answerDoc.id, score: answerDoc.data().finalScore});// 
            });
          }
        );
      },

  	async _getStudentFrom(studentsSnapshot, students){
    	for(const doc of studentsSnapshot.docs){
      	let student=doc.data();
      	student.id = doc.id;
      	student.ref=doc.ref;
      	student.topics=[];
      	student.finalScore=null;
 
      	fb.db.collection('schools/'+this.schoolId+'/lessons/'+this.lessonId+"/studentList").doc(student.id).onSnapshot(studentDoc=>{
        	if(studentDoc.exists && studentDoc.data() && studentDoc.data().finalScore)
          	student.finalScore=studentDoc.data().finalScore;
      	});
      	var tmp=[];
      	student['calculatedScore'] = 0;
      	for(var topic of this.topics){
        	var scoreDoc=Object.assign({}, topic);
        	let score=Object.assign({}, {topic: scoreDoc, data:{earnedScore:null}, procent:0});
       	 
        	if(student){
          	var y = {topic: scoreDoc};
          	y.data={earnedScore:null};
          	fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId+"/scores/"+topic.id).collection('sstudents').doc(student.id).onSnapshot(sdoc=>{
            	if(sdoc.exists){
              	score.data=sdoc.data();
            	}
          	});

          	fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId+"/scores/"+topic.id).collection('sstudents').doc(student.id).get().then(sdoc=>{
            	if(sdoc.exists){
              	student['calculatedScore'] = student['calculatedScore'] + Math.round((score.data.earnedScore*score.topic.totalProcent)/100).toFixed(2)*1;
            	}
          	});
        	}
       	 
        	student.topics.push(score);
       	 
        }
        await this._getScores(student);
      	students.push(student);
 
    	}
        	 
  	},
  	async getStudentsFromGroup(group){
    	var studentsSnapshot;
    	if(group.isGroup && group.isGroup==true){
      	studentsSnapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("lessonGroups", "array-contains", group.group).orderBy("name", "asc").get();
    	}
    	else {
      	studentsSnapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", group.program).orderBy("name", "asc").get();
    	}
   	 
    	if(studentsSnapshot && !studentsSnapshot.empty){
      	group.students=[];
      	await this._getStudentFrom(studentsSnapshot, group.students);
    	}
  	},
  	async getStudents(){
 
    	if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
      	if(this.allGroups){
        	for(const group of this.groups){
          	this.getStudentsFromGroup(group);
        	}
      	} else{
        	this.getStudentsFromGroup(this.currentSelectedGroup);
      	}
    	}
  	},
  	async calStudentScore(student){
    	for(const topic of student.topics){
      	console.log(topic.data);
    	}
  	},
  	async resetStudents(){
    	if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
      	for(const group of this.groups){
        	if(group && group.students && group.students.length>0){

          	for(const object of group.students){
            	object.topics=[];
        	 
            	for(const topic of this.topics){

              	var scoreDoc=Object.assign({}, topic);
              	let score=Object.assign({}, {topic: scoreDoc, data:{earnedScore:null}, procent:0});
             	 
              	if(object){
                	var y = {topic: scoreDoc};
                	y.data={earnedScore:null};
                	fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId+"/scores/"+topic.id).collection('sstudents').doc(object.id).onSnapshot(sdoc=>{
                  	if(sdoc.exists){
                    	score.data=sdoc.data();
                    	// this.$set(score, 'data', y.data);
                  	}
                	});
              	}
              	object.topics.push(score);
            	}
          	}
        	}
      	}
    	}
  	},


  	async getTopics(){
    	this.topics=[];
    	if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
      	var topicSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("scores").orderBy("totalProcent","asc").get();
      	if(topicSnapshot && !topicSnapshot.empty){
        	this.topics=[];
        	for(const doc of topicSnapshot.docs){
          	let object=doc.data();
          	object.id = doc.id;
          	object.groups=[];
          	object.procent=0;
          	object.ref = doc.ref;
          	if(object && object.countScore && object.sumScore){
            	object.procent=(80);
          	}
         	 
          	this.topics.push(object);
        	}
       	 
      	}
     	 
    	}
  	},
  	_addTopic(gdata, i, j){
    	this.dayStr=null;
    	this.selectedTopicIndex=i;
    	this.selectedGroupIndex=j;
    	this.selectedCell=gdata;
    	$('#exampleModal').modal('toggle');
  	},
  	_chooseTeacher(gdata, i, j){
    	this.teacher=null;
    	this.selectedTopicIndex=i;
    	this.selectedGroupIndex=j;
    	this.selectedCell=gdata;
    	$('#teacherModal').modal('toggle');
  	},
 	 
 
  	setProperty(propertyName, object, value){
    	if(object!=null && propertyName!=null){
      	var tmp={};
      	tmp[propertyName]=value;
      	object.update(tmp);
    	}
  	},
    
  	setPublished(value, lesson){

  	},
  	setPropContent(value,topic, item, propertyName){
    	if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
      	this.setProperty(propertyName, fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
  	},

  	_addProgram(){
    	if(this.selectedCell && this.dayStr && this.dayStr!=''){
      	if(this.selectedCell.exists){
        	this.selectedCell.ref.update({
          	"date": new Date(this.dayStr)
        	});
      	}
      	else
        	this.selectedCell.ref.set({
          	"date": new Date(this.dayStr)
        	});
      	this.selectedCell.date=fb.firestore.Timestamp.fromDate(new Date(this.dayStr));
     	 
      	// if(this.selectedTopicIndex && this.selectedGroupIndex){
      	//   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
      	// }
    	}
    	else{
      	alert("Та мэдээллээ бүрэн оруулна уу.");
    	}
  	},
    	findStudents(sc, dep, pro){
      	fb.db.collection("schools/"+this.schoolId+"/students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
        	for(const studentData of docs.docs){
         	 
          	if(studentData!=null && studentData.exists){
            	var studentDetail=studentData.data();
            	this.addStudentToLesson(fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id), studentData, studentDetail);
          	}
        	}
      	});
    	},
    	 
    	async scoreChanged(student, score){

			if(student && student.id && score && score.topic && score.topic.id && score.data && score.data.earnedScore){
				student.calculatedScore=0;
				var maxScore=100;
				if(score.topic && score.topic.totalScore){
					maxScore=score.topic.totalScore;
				}
				if(score.data.earnedScore> maxScore){
					alert("Дээд онооноос хэтэрсэн байна.");
					fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
						modifiedAt: new Date()
					}, {merge:true});
					return ;
				}
				var procent=null;
				if(maxScore){
					procent=(score.data.earnedScore*100/maxScore)
				}
				var createdDate = new Date();
				fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
					modifiedAt: createdDate,
					earnedScore:score.data.earnedScore,
					procent: procent
				}, {merge:true});
	
				this.actionstatus=student.name+', '+score.data.earnedScore +" дүн оруулсан: "
				
				var summe = 0;
				for(const changedScore of student.topics){
					var tmp=(changedScore.data.earnedScore*changedScore.topic.totalProcent)/100;
					summe +=tmp;
				}
				student.calculatedScore = Math.round(summe).toFixed(2)*1;
			}
    	},
    	async finalScoreChanged(student){
			console.log(this.lessonId);
			if(student && student.id && student.finalScore){
				// var maxScore=100;
				// if(score.topic && score.topic.totalScore){
				//   maxScore=score.topic.totalScore;
				// }
				// if(score.data.earnedScore> maxScore){
				//   alert("Дээд онооноос хэтэрсэн байна.");
				//   fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("scores").doc(score.topic.id).collection('sstudents').doc(student.id).set({
				// 	modifiedAt: new Date()
				//   }, {merge:true});
				//   return ;
				// }
				// var procent=null;
				// if(maxScore){
				//   procent=(score.data.earnedScore*100/maxScore)
				// }
				var studentDoc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("studentList").doc(student.id).get();
				var createdDate= new Date();
				if(studentDoc.exists){
				studentDoc.ref.update({
					scoreModifiedAt: createdDate,
					finalScore:student.finalScore,
					// procent: procent
				}).then(async xx=>{
					await fb.db.collection("schools/"+this.schoolId+"/students").doc(student.id).collection("finalGrades").doc(this.lessonId).set(
					{
						createdAt: new Date(),
						finalScore:student.finalScore,
						'semester': '2020-II'
					},);
					this.actionstatus=student.name+', '+student.finalScore +" дүн оруулсан: "
					console.log('saved final updated score');
				});
		//TODOxx
        	}
        	else {
           	studentDoc.ref.set({
            	scoreModifiedAt: new Date(),
            	finalScore:student.finalScore,
            	addedDate: createdDate,
            	studentRef: student && student.ref? student.ref:null,
            	// addedUser:
            	// procent: procent
          	});
          	this.actionstatus=student.name+', '+student.finalScore +" дүн оруулсан: "
        	}
      	}
    	},
    	addScore(){
      	this.content={"name":null, "totalScore":100};
      	$('#scoreModal').modal('toggle');
    	},
   	 
    	_editScore(topic){
      	this.content=Object.assign({}, topic);
      	this.content.editing=true;
      	$('#scoreModal').modal('toggle');
    	},
    	async addNewScore(name, totalScore){

      	var score = {name:name, totalScore:totalScore};
      	score.createdAt=new Date();
      	score.code=new Date().getTime().toString();
      	var scoreRef= fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("scores").doc();
      	await scoreRef.set(score);
    
     	 
      	fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
        	'numberOfYvts':fb.firestore.FieldValue.increment(1)
      	});

      	let object=Object.assign({},score);
      	object.id = scoreRef.id;
      	object.groups=[];
      	object.procent=0;

      	this.topics.push(object);
      	// this.resetStudents();
    	},
    	async saveScore(){
      	if(this.content!=null && this.content.name!=null && this.content.name!='' && this.content.totalScore&& this.content.totalProcent){

        	if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
          	this.content.modifiedAt=new Date();
          	fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("scores").doc(this.content.id).update(this.content);
          	this._initData();
        	}
        	else{
          	this.content.createdAt=new Date();
          	this.content.code=new Date().getTime().toString();
          	var contentRef= fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).collection("scores").doc();
          	await contentRef.set(this.content);
    
     	 
          	fb.db.doc('schools/'+this.schoolId+"/lessons/"+this.lessonId).update({
            	'numberOfYvts':fb.firestore.FieldValue.increment(1)
          	});

          	let object=Object.assign({}, this.content);
          	object.id = contentRef.id;
          	object.groups=[];
          	object.procent=0;
          	object.ref=contentRef;
 
          	this.topics.push(object);
          	this.resetStudents();

        	}
           	 
        	this.content={
          	'name':null
        	}
 	 
        	$('#scoreModal').modal('hide');
      	}
      	else{
        	alert("Та талбаруудыг гүйцэд бөглөнө үү");
      	}
    	},
  	_getAvg(topics){
    	// console.log(topics);
    	var sum=0;
    	var count=0;
    	for(const topicScore of topics){
      	if(topicScore && topicScore.data && topicScore.data.earnedScore){
        	sum+=topicScore.data.earnedScore;
        	count++;
       	 
      	}
    	}
    	if(count!=0){
      	return Math.round( sum/count);
    	}
    	return null;
  	}
  	,
  	_getSum(studentTopics){
    	var sum=0;
    	var count=0;
   
    	for(const topicScore of studentTopics){
       	 
      	if(topicScore&&topicScore.data){
   
        	//sum+=(topicScore.data.earnedScore* topicScore.score.totalProcent)/100;
        	count++;
      	}
    	}
    	// if(count!=0){
    	//   return Math.round(sum);
    	// }
    	return sum;
    	return null;
  	},
	},
	computed: {
    	...mapState(['userProfile', 'currentUser'])
	},
	components: {
  	VueQrcode,
  	LessonInfo
	},
	props: {
  	schoolId:{
    	required:true
  	},
  	lessonId: {
      	required: true,
  	},
  	programId:{
    	required:false
  	},
  	groupId:{
    	required:false
    },
    topicId:{
      required:true
    },
    contentId:{
      required:true
    }
	},
	created() {

  	// /schools/xUSN7smB3EcLwDYhs1Y9/departments/6xvVvEq1CzxW7vUx8Nnl/programs/xz0KhaYquJpyjT8oJL4h
 	 
  	fb.db.collection("schools").doc(this.schoolId).onSnapshot(doc=> {
      	let school=doc.data()
      	school.id=doc.id
      	this.school=school;
  	});

  	fb.db.collection("schools").doc(this.schoolId).onSnapshot(doc=> {
      	let school=doc.data()
      	school.id=doc.id
      	this.school=school;
  	});

  	if(this.lessonId!=null && this.lessonId!=''){
      	this._initData();
    }
    
	},
	filters: {
   	   formatDate(val) {
      	if (!val) { return '-' }
      	let date = val.toDate()
      	return moment(date).format('MM/DD/YYYY HH:mm');
  	},
	}
 
};
</script>


<style>
  ::placeholder{
	color: #bbb!important;
	font-size: 10pt;
  }
  .scorehead{
	width: 12%;
  }
  .score-table.form-control{
	height: calc(1.8em)!important;
	border-radius: 0rem;
  }
  .score-table {
	width: 100%;
	margin-bottom: 1rem;
	color: #000;
  }
  .alignRight {
	text-align: right;
  }
  .alignLeft {
	text-align: left;
  }
  .table td, .table th {
	vertical-align: middle;
	border-top: 1px solid #e3e6f0;
  }
  .b3-collapsing-form-additional-icons {
	display: inline-block;
	height: 24px;
	margin-bottom: -12px;
	margin-top: -12px;
	padding: 12px;
}
.svg-icon {
	cursor: pointer;
	display: inline-block;
	fill: #80868b;
 	/* rgba(0,0,0,0.38);  */
	-webkit-transition: fill .25s linear;
	transition: fill .25s linear;
	width: 24px;
}
.svg-icon:hover{
  fill:rgba(0,0,0,0.78);  
}
</style>
